module.exports = __webpack_public_path__ + "static/media/scissors_lose.93ed92ee.png";